import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import CategoryForm from '../../components/form/category-form';

export default function CategoryAdd() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Add Category"}
                    is_main_page={false}
                />
                <CategoryForm
                    mode={'add'}
                    button_title={'Add'}
                />
            </Container>
        </>
    )
}